<mat-select id="{{idPrefix}}mode"
            class="mat-stroked-button"
            [(ngModel)]="selected"
            (ngModelChange)="onSelectionChange()">
  <mat-option *ngFor="let option of options" id="{{idPrefix}}mode.{{option.key}}" [value]="option" >
    {{ option.trans }}
  </mat-option>
</mat-select>
